import { Image } from "@chakra-ui/react";
import React from "react";

export const MobileWeddingBackground = React.memo(() => {
  return <Image src={require("assets/wedding-background.png")} />;
});
